<template>
  <div class="flex items-center justify-between w-full">
    <span class="transactions-list-title">{{ $t("component.transactionList.title") }}</span>
  </div>
  <div class="div-separator-32"></div>
  <TransactionDay v-for="(transactions, index) in transactionsByDay" :transactions="transactions" />
</template>

<script setup>
  import { onMounted, ref } from "vue";
  import { ceApiService } from "@/_services/ceApiService";
  import TransactionDay from "@/components/Transaction/TransactionDay.vue";

  const props = defineProps({
    'campaignUuid': {
      type: String,
      default: null
    },
  });

  let transactionsByDay = ref([]);

  onMounted(async () => {
    const response = await ceApiService.getTransactionsCampaigns(props.campaignUuid);
    transactionsByDay.value = response.data["hydra:member"];
  });
</script>

<style scoped lang="scss">
  .transactions-list-title {
    color: #275CF1;
    font-size: 20px;
    font-weight: 700;
  }
</style>